var _style, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConectaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.7966,
    y1: -6.9929,
    x2: 1.0793,
    y2: 55.6158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1932,
    style: {
      stopColor: "#4CB931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    style: {
      stopColor: "#46B341"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4376,
    style: {
      stopColor: "#37A56B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    style: {
      stopColor: "#1E8EAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7826,
    style: {
      stopColor: "#1080D6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.91,41.49c0-0.98,0.22-1.9,0.69-2.76c0.11-0.21,0.09-0.33-0.07-0.49c-2.53-2.51-5.05-5.03-7.56-7.56 c-0.19-0.19-0.33-0.17-0.56-0.09c-3.69,1.25-7.44-1.02-8.05-4.88c-0.55-3.42,2.22-6.78,5.68-6.9c0.89-0.03,1.75,0.06,2.58,0.41 c0.2,0.08,0.31,0.04,0.46-0.1c2.46-2.47,4.92-4.93,7.39-7.38c0.23-0.22,0.13-0.38,0.04-0.59c-1.53-3.46,0.29-7.49,3.84-8.52 c4.2-1.22,8.26,2.23,7.77,6.58c-0.08,0.7-0.22,1.38-0.54,2.01c-0.12,0.23-0.04,0.34,0.11,0.49c2.44,2.44,4.88,4.87,7.32,7.32 c0.21,0.21,0.37,0.21,0.64,0.12c3.4-1.17,7.02,0.78,7.88,4.26c0.56,2.27-0.03,4.28-1.73,5.88c-1.71,1.62-3.76,2.05-6.01,1.36 c-0.4-0.12-0.63-0.07-0.92,0.23c-2.43,2.45-4.87,4.89-7.32,7.32c-0.24,0.23-0.25,0.39-0.11,0.69c1.08,2.34,0.86,4.59-0.8,6.57 c-1.64,1.96-3.82,2.64-6.28,1.94c-2.48-0.7-3.92-2.44-4.38-4.97C18.92,42.11,18.93,41.8,18.91,41.49z M35.82,21.17 c-0.1-0.11-0.18-0.21-0.27-0.3c-2.31-2.32-4.62-4.63-6.93-6.95c-0.19-0.2-0.32-0.23-0.57-0.08c-2,1.13-4.02,1.12-6.03,0 c-0.25-0.14-0.37-0.12-0.57,0.08c-2.31,2.33-4.64,4.66-6.97,6.98c-0.18,0.18-0.21,0.28-0.06,0.52c1.45,2.25,1.44,4.51-0.01,6.76 c-0.13,0.21-0.12,0.31,0.05,0.48c2.43,2.45,4.86,4.9,7.28,7.36c0.18,0.18,0.31,0.2,0.54,0.08c1.8-0.92,3.62-0.93,5.42,0 c0.23,0.12,0.37,0.14,0.58-0.07c2.43-2.45,4.87-4.89,7.32-7.32c0.17-0.17,0.22-0.28,0.07-0.51c-1.46-2.25-1.45-4.51-0.01-6.76 C35.7,21.34,35.76,21.26,35.82,21.17z M12.32,24.9c0.01-1.64-1.26-2.96-2.89-2.98c-1.65-0.02-2.97,1.26-2.99,2.88 c-0.02,1.67,1.26,2.99,2.92,3C10.99,27.82,12.31,26.53,12.32,24.9z M43.57,24.89c0.01-1.64-1.27-2.96-2.9-2.97 c-1.65-0.01-2.96,1.26-2.98,2.89c-0.02,1.65,1.26,2.98,2.88,3C42.23,27.83,43.56,26.54,43.57,24.89z M22.06,41.45 c-0.01,1.64,1.28,2.95,2.91,2.96c1.66,0.01,2.97-1.29,2.97-2.95c0-1.63-1.3-2.93-2.94-2.94C23.37,38.53,22.07,39.82,22.06,41.45z  M24.98,11.6c1.64,0,2.95-1.3,2.95-2.92c0.01-1.64-1.29-2.95-2.92-2.96c-1.66-0.01-2.97,1.29-2.97,2.95 C22.05,10.3,23.35,11.6,24.98,11.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.6566,
    y1: 7.8903,
    x2: 13.1784,
    y2: 36.4555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1932,
    style: {
      stopColor: "#4CB931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2556,
    style: {
      stopColor: "#4AB737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3401,
    style: {
      stopColor: "#43B148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4373,
    style: {
      stopColor: "#39A765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    style: {
      stopColor: "#2B998C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6569,
    style: {
      stopColor: "#1888BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7044,
    style: {
      stopColor: "#1080D6"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25,
    cy: 25,
    r: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConectaIcon);
export default __webpack_public_path__ + "static/media/conecta-icon.74a0d3029c178ef3e9d817ef9c731422.svg";
export { ForwardRef as ReactComponent };